import type { ComponentClassNames } from '../../../../util/classNames';
import type { Depth } from '../../../../util/styles/depth';
import { getDepthBoxShadow } from '../../../../util/styles/depth';
import { memoizeFunction, mergeStyleSets } from '../../../../util/styling';
import type { ColorToken } from '../../../../util/theme/fluent9';

type HeaderClassNames = ComponentClassNames<'header'>;

export const getClassNames = memoizeFunction((depth: Depth, backgroundColor?: ColorToken): HeaderClassNames => {
  const boxShadow = getDepthBoxShadow(depth);

  return mergeStyleSets({
    header: {
      boxShadow,
      backgroundColor,
    },
  });
});
